import { FC } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

export const CardContainer: FC<FlexProps> = ({ children, ...props }) => {
  return (
    <Flex
      bg="th.white"
      borderRadius="1rem"
      border="1px solid"
      borderColor="th.cream2"
      boxShadow="0px 14px 34px rgba(0, 0, 0, 0.05)"
      direction="column"
      px={{ base: "1.5rem", md: "1.875rem" }}
      py={{ base: "1.25rem", md: "1.5rem" }}
      w="full"
      {...props}
    >
      {children}
    </Flex>
  );
};
